<template>
  <TheBaseGrid :showEditor="false" editorHeader="Eksempel" editorHeight="136px" @next="checkInput">
    <template slot="intro">
      <h2>CSS Box Model</h2>
      <p>
        Alle HTML-elementer kan betragtes som kasser. I CSS bruges udtrykket "boxmodel", når man taler om design og layout.
      </p>
      <p>
        CSS-boksemodellen er en boks, der ombryder rundt om hvert HTML-element. Den består af: margins, borders, padding og det egentlige indhold. Billedet til højre illustrerer boxmodellen:
      </p>
    </template>
    <template slot="cssInput">
      <pre class="before">h1 {
  {{cssInput}}</pre><pre class="after">}</pre>
    </template>

    <template slot="output">
      <div class="boxmodel">
        <div class="margin">
          <div class="border">
            <div class="padding">
              <div class="content">
              </div>
             </div>
          </div>
        </div>
      </div>
    </template>

  </TheBaseGrid>
</template>

<script>
import TheBaseGrid from '@/components/TheBaseGrid.vue'
export default {
  name: 'episode0',
  data () {
    return {
      cssInput: `color:red;`
    }
  },
  components: {
    TheBaseGrid
  },
  computed: {
  },
  methods: {
    checkInput(){
      this.$router.push({ path: '/season/2/episode/1' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.boxmodel{
  & .margin{
    background: #f1f1f1;
    padding: 30px;
    width: 100%;
    height: 100%;
    position: relative;
    border: 2px dashed #bbb;
    &:before {
      content: "margin";
      position: absolute;
      left: 0;
      top: 1.5%;
      width: 100%;
      text-align: center;
    }
  }
  & .border{
    background: var(--color-link);
    padding: 30px;
    width: 100%;
    height: 100%;
    position: relative;
    border: 2px dashed #bbb;
    &:before {
      content: "border";
      position: absolute;
      left: 0;
      top: 1.5%;
      width: 100%;
      text-align: center;
    }
  }
  .padding{
    background: #f1f1f1;
    padding: 30px;
    width: 100%;
    height: 100%;
    position: relative;
    border: 2px dashed #bbb;
    &:before {
      content: "padding";
      position: absolute;
      left: 0;
      top: 1.5%;
      width: 100%;
      text-align: center;
    }
  }
  .content{
    background: #fff;
    padding: 30px;
    width: 100%;
    height: 100%;
    position: relative;
    border: 2px dashed #bbb;
    &:before {
      content: "Indhold";
      position: absolute;
      left: 0;
      top: 1.5%;
      width: 100%;
      text-align: center;
    }
  }

}
</style>
